@use "../../style/variables" as *;
@use "../../style/mixins" as *;

.image-container {
  height: auto;
  width: 100%;
  position: relative;
}

.image {
  height: auto;
  width: 100%;
  display: block;

  +.overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    opacity: 0.4;
    background-color: $black;
  }
}

.headline {
  position: absolute;
  margin: 0;
  top: 50%;
  left: 50%;
  width: 100%;
  text-align: center;
  transform: translate(-50%, -50%);
  font-size: 1.5em;
  text-transform: uppercase;
  color: white;
  font-weight: bold;

}

.text {
  margin-top: 0.75rem;
  color: $grey-text;
  font-size: 0.875rem;
  font-weight: 300;
  width: 100%;
  line-height: 1.125rem;

  @include mobile {
    padding-right: 1.5625rem;
    padding-left: 1.5625rem;
  }
}